<template>
    <div
        :data-component="$options.name"
        class="flex flex-col items-center justify-center gap-16"
    >
        <div
            v-if="isStateVisible"
            class="text-color-neutral-grey-60"
        >
            {{ limitedCurrent }} von {{ maxFormatted }} {{ label }} geladen
        </div>

        <div
            v-if="!isReduced"
            class="h-4 overflow-hidden rounded w-custom bg-color-neutral-grey-10"
            data-jest="progress"
        >
            <div
                class="w-full h-full transition-transform duration-300 rounded bg-color-neutral-black ms-ease"
                :style="{
                    transform: `translateX(-${computedRight}%)`,
                }"
            ></div>
        </div>

        <cs-secondary-button
            v-if="!isMaxReached"
            :isLoading="isLoading"
            @click="onClick"
        >
            <slot />
        </cs-secondary-button>
    </div>
</template>

<script lang="ts" src="./CsLoadMore.ts" />
<style scoped lang="scss" src="./CsLoadMore.scss" />
